import React from "react";

const SalesByCreditNotesReport = ({ resPacket }) => {
  return (
    <div>
      {resPacket && resPacket.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <th>SNO.</th>
                <th className="pl-4">CREDIT NUMBER</th>
                <th className="pl-4">CREDITNOTE DATE</th>
                <th className="pl-4">INVOICE NUMBER</th>
                <th className="pl-4">INVOICE DATE</th>
                <th className="pl-4">CUSTOMER NAME</th>
                <th className="pl-4">CUSTOMER CATEGORY</th>
                <th className="pl-4">SUBTOTAL AMOUNT</th>
                <th className="pl-4">TAX AMOUNT</th>
                <th className="pl-4">TOTAL AMOUNT</th>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((row, i) => (
                <tr key={i}>
                  <td>{i+1}</td>
                  <td>{row.creditNumber}</td>
                  <td>{row.creditNoteDate}</td>
                  <td>{row.invoiceNumber}</td>
                  <td>{row.invoiceDate}</td>
                  <td>{row.customerName}</td>
                  <td>{row.customerCategory}</td>
                  <td>{row.subTotalAmount}</td>
                  <td>{row.taxAmount}</td>
                  <td>{row.totalAmount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="my-3 text-black text-center">No Records Found</div>
      )}
    </div>
  );
};

export default SalesByCreditNotesReport;
